import { useState, useEffect } from 'react';
import { Control } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { SectionTitle, MyAutocomplete } from '@/components';
import { appSetNotification } from '@/store';
import { usersProvider } from '@/providers';
import { IErrors } from '../../../../uiComponents/types';
import { NotificationTypeEnum } from '@/types';
import styles from './WorkData.module.scss';
import { specialization, propertyType } from '../../../utils/fakeData';

export const WorkData = ({
  errors,
  control,
  isCheckedBroker,
  isCheckedManager,
}: {
  errors: IErrors;
  control: Control;
  isCheckedBroker: boolean;
  isCheckedManager: boolean;
}) => {
  const [inputAutocompleteValue, setAutocompleteValue] = useState('');
  const [areas, setAreas] = useState<string[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    handleOnChangeAutocomplete(inputAutocompleteValue);
  }, [inputAutocompleteValue]);

  const handleOnChangeAutocomplete = async (param: string) => {
    if (!param) {
      setAreas([]);
      return;
    }
    try {
      const { ok, data, status, message } = await usersProvider.getOperationRegion({
        query: param,
      });
      if (!ok || !data) {
        dispatch(
          appSetNotification(NotificationTypeEnum.Error, message || 'Unknown error', status)
        );
        setAreas([]);
        return;
      }
      if (typeof data === 'object' && 'items' in data && Array.isArray(data.items)) {
        const options = data.items.map((item) => item.name);
        setAreas(options);
      } else {
        setAreas([]);
      }
    } catch (error) {
      dispatch(appSetNotification(NotificationTypeEnum.Error, 'An error occurred', 500));
      setAreas([]);
    }
  };

  return (
    <div>
      <SectionTitle number={isCheckedBroker ? 4 : 3} title='Work Data' />
      <div className={styles.container}>
        <div className={styles.row}>
          {!isCheckedManager && (
            <div className={styles.row}>
              <MyAutocomplete
                errors={errors}
                control={control}
                data={{
                  name: 'specialization',
                  label: 'Specialization',
                  options: specialization,
                  multiple: true,
                  placeholder: 'Choose your specialization',
                }}
              />
              <MyAutocomplete
                errors={errors}
                control={control}
                data={{
                  name: 'propertyType',
                  label: 'Property type',
                  options: propertyType,
                  multiple: true,
                  placeholder: 'Choose property type',
                }}
              />
            </div>
          )}
          <div className={styles.myAutocomplete}>
            <MyAutocomplete
              errors={errors}
              control={control}
              changeAutocompleteValue={setAutocompleteValue}
              data={{
                name: 'regionOfOperation',
                label: 'Areas',
                multiple: true,
                options: areas,
                placeholder: 'Choose location',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
